import {checkDeviceMobile, setElementAnimateOffsetResponsive} from "../../../libs/helper";
import {gsap} from "gsap";
import Services from "../../../libs/services";
import {Drag} from "../../system/drag/drag";
import EmitEvent, {HT_RESIZE, PAGE_ENTER} from "../../../libs/emit-event";

export class ElementProjectGallery {
    constructor() {
        this.DOM = {main: document.querySelector('.js-galleryContainer')};

        if (!this.DOM.main) return;

        this.pageEnter = this.pageEnter.bind(this);
        this.htResize = this.htResize.bind(this);
        this.updateDragValue = this.updateDragValue.bind(this);

        this.DOM.container = this.DOM.main.querySelector('.js-galleryContainer_container');
        this.DOM.list = this.DOM.main.querySelector('.js-galleryContainer_list');
        this.DOM.galleryItems = this.DOM.main.querySelectorAll('.js-gallery_item');

        this.drag = new Drag({
            el: this.DOM.main,
            updateDragValue: this.updateDragValue,
            animationIn: this.animationIn.bind(this),
            updateProp: this.getProp.bind(this)
        });

        this.emitEvent();
    }

    animationIn() {
        gsap.to(this.DOM.galleryItems, {
            y: 0, opacity: 1, ease: 'power3.out', duration: .8,
            stagger: .1,
        });
        setTimeout(() => this.drag.readyDrag = true, 800);
    }

    getProp() {
        const paddingLeft = window.getComputedStyle(this.DOM.galleryItems[0], null).getPropertyValue('padding-left');
        const {width} = this.DOM.container.getBoundingClientRect();
        this.drag.style.transition.maxDrag = this.DOM.list.scrollWidth - width - (paddingLeft.replace('px', '') * 2);
        this.drag.style.bonus = (Services.winSize.width * .3);
    }

    updateDragValue(current) {
        this.DOM.container.style.transform = `translate3d(${current}px, 0, 0)`;
    }

    pageEnter() {
        this.getProp();
        if (!checkDeviceMobile()) {
            gsap.set(this.DOM.galleryItems, {opacity: 0, y: 60});
            if (this.drag.animationHelper && this.drag.animationHelper.isInViewPointer()) {
                this.animationIn();
            }
        }
    }

    htResize() {
        this.drag.style.transition.last = Math.min(Math.max(this.drag.style.transition.last, -this.drag.style.transition.maxDrag), 0);
        this.drag.renderDrag();
    }

    emitEvent() {
        EmitEvent.on(HT_RESIZE, this.htResize);
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
    }

    removeEvent() {
        if (!this.DOM.main) return;
        EmitEvent.off(HT_RESIZE, this.htResize);
        EmitEvent.off(PAGE_ENTER, this.pageEnter);
        if (this.drag) {
            this.drag.removeEvent();
        }
    }

}
